<div class="container">
    <div class="general">
        <h2>General</h2>
      <mat-form-field appearance="fill">
        <mat-label>Available Translations:</mat-label>
        <input type="text" matInput #startAmount />
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Select language</mat-label>
        <mat-select>
          <mat-option *ngFor="let language of languages" [value]="language">
            {{language}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Gradient:</mat-label>
        <input type="text" matInput #minAmount />
      </mat-form-field>
    </div>
      <!-- termtransl -->
      <!-- <div class="termTranslationTable">
        <h2>Term | Translation</h2>
        <table mat-table [dataSource]="dataSource">
          <ng-container matColumnDef="{{col}}" *ngFor="let col of displayedColumns">
            <th mat-header-cell *matHeaderCellDef>
              <span *ngIf="col !== '$$edit'">
                {{col}}
              </span>
            </th>
            <td mat-cell *matCellDef="let element">
              <div *ngIf="!element.isEdit">
                <div class="btn-edit" *ngIf="col === '$$edit'; spanHeader" >
                  <button (click)="element.isEdit = !element.isEdit">Edit</button>
                </div>
                <span #spanHeader>
                  {{element[col]}}
                </span>
              </div>
              <div *ngIf="element.isEdit">
                <div class="btn-edit" *ngIf="col === '$$edit'; else dataField">
                  <button (click)="element.isEdit = !element.isEdit">Done</button>
                </div>
                <ng-template #dataField>
                  <mat-form-field>
                    <mat-label>{{col}}</mat-label>
                    <input type="{{dataSchema[col]}}" matInput value="{{element[col]}}">
                  </mat-form-field>
                </ng-template>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div> -->
        <!-- termtransl -->
    <div class="previewHolder">
      <app-preview></app-preview>
    </div>
</div>
